import { useMutation, useQuery, useQueryClient } from 'react-query';
import { companyTransfer, StartTransferBody } from '../../../API/TT_ELD/companyTransfer';

const STATUS_POLL_MS = 5000;

// Polls while the transfer is running, stops once it is done / partial / failed
export const useTransferStatus = (companyId: string | number | undefined) =>
  useQuery(['company-transfer-status', companyId], () => companyTransfer.status(companyId!), {
    refetchOnWindowFocus: false,
    enabled: !!companyId,
    refetchInterval: (data) => (data?.status === 'running' ? STATUS_POLL_MS : false),
  });

export const useTransferHistory = (companyId: string | number | undefined) =>
  useQuery(['company-transfer-history', companyId], () => companyTransfer.history(companyId!), {
    refetchOnWindowFocus: false,
    enabled: !!companyId,
  });

// Starting / retrying changes the company (eldStatus, is_active), the status and the history
const useTransferMutation = <TVars>(
  companyId: string | number | undefined,
  fn: (vars: TVars) => Promise<unknown>,
) => {
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSettled: () => {
      queryClient.invalidateQueries(['company-transfer-status', companyId]);
      queryClient.invalidateQueries(['company-transfer-history', companyId]);
      queryClient.invalidateQueries(`companies/${companyId}`);
    },
  });
};

export const useStartTransfer = (companyId: string | number | undefined) =>
  useTransferMutation(companyId, (body: StartTransferBody) => companyTransfer.start(companyId!, body));

export const useRetryTransfer = (companyId: string | number | undefined) =>
  useTransferMutation(companyId, (_: void) => companyTransfer.retry(companyId!));
